<template>
  <span :class="[$style.loader, { [$style.overlay]: overlay }]">
    <svg :class="$style.ring" viewBox="25 25 50 50" stroke-width="5">
      <circle cx="50" cy="50" r="20" />
    </svg>
  </span>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    overlay: {
      default: false,
      type: Boolean
    }
  }
};
</script>

<style lang="scss" module>
// @TODO Abstract out colors & font-sizes to make this reusable & customizable.
.loader {
  align-items: center;
  display: inline-flex;
  height: 100%;
  justify-content: center;
  width: 100%;

  &.overlay {
    background-color: $primaryContrastAlpha1;
    left: 0;
    position: absolute;
    top: 0;
    z-index: 100;
  }
}

.ring {
  font-size: 36px;
  height: 1em;
  width: 1em;
  vertical-align: middle;
  transform-origin: center;
  animation: rotate 2s linear infinite;
}

.ring circle {
  fill: none;
  stroke: currentColor;
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  stroke-linecap: round;
  animation: stretch calc(2s * 0.75) ease-in-out infinite;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes stretch {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dashoffset: -124px;
  }
}
</style>
